import React, {PropsWithChildren, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {getCurrentYear} from '../../../util/util';
import {DateTimeFormat, formatDateTime, getYearData} from '../../../../utils/dateTimeUtils';
import CalendarGraph from '../../../components/graphs/CalendarGraph';
import {selectedPresentationSelector} from '../../../../store/selectors/presentation.selectors';
import {CalendarAnalytics} from '../../../../incase-domain/analytics';
import SkeletonLoader from '../../../components/common/SkeletonLoader';
import Label from '../../../../incase-domain/components/label/Label';
import {DropdownMenuCompactTileProps} from '../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompactTile';
import DropdownMenuCompact, {
    DropdownMenuCompactMenuPosition,
} from '../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import Button from '../../../../incase-domain/components/button/Button';

interface CalendarReportProps {
    calendarAnalytics: CalendarAnalytics | undefined;
    isLoading: boolean;
}

function InteractionsCalendar(props: PropsWithChildren<CalendarReportProps>): JSX.Element {
    const {calendarAnalytics, isLoading} = props;
    const {t} = useTranslation();

    const selectedPresentation = useSelector(selectedPresentationSelector);

    const [selectedYear, setSelectedYear] = useState(getCurrentYear().toString());

    const calendarAnalyticsRef = useRef(null);

    const filteredDailyAccesses = calendarAnalytics?.dailyAccesses?.filter(
        (access) => new Date(access.day).getFullYear().toString() === selectedYear
    );

    const yearItems: DropdownMenuCompactTileProps[][] = [
        getYearData(formatDateTime(selectedPresentation.created, DateTimeFormat.YEAR)).map((year) => ({
            label: year.label,
            onClick: () => setSelectedYear(year.value),
        })),
    ];

    return (
        <div>
            <div className="u-flex u-h-between u-v-bottom">
                <div className="p-presReport__card_title">{t('reportPage.calendarDistribution')}</div>
                <div className="interactionCalendar__select">
                    <DropdownMenuCompact
                        menuPosition={DropdownMenuCompactMenuPosition.LEFT}
                        className="c-sidepanel__dropdown"
                        items={yearItems}
                    >
                        <Button className="c-sidepanel__dropdown_button" fullWidth trailing="solar:alt-arrow-down-linear" variant="ghost">
                            {selectedYear}
                        </Button>
                    </DropdownMenuCompact>
                </div>
            </div>
            <div className="p-presReport__card">
                <SkeletonLoader isLoading={isLoading} props={{style: {minHeight: '16rem'}}}>
                    <div className="interactionCalendar">
                        <div className="interactionCalendar__body" ref={calendarAnalyticsRef}>
                            <Label size="md">{t('reportPage.calendar.heatMapSub')}</Label>
                            <CalendarGraph data={filteredDailyAccesses || []} from={selectedYear} to={selectedYear} isLoading={isLoading} />
                        </div>
                    </div>
                </SkeletonLoader>
            </div>
        </div>
    );
}

export default InteractionsCalendar;
